import React, { Component } from 'react';
import {
    Paper,
    Typography,
    Box,
    Card,
    CardContent,
    CardHeader,
    Collapse,
    IconButton,
    TextField,
    Button,
    Checkbox,
    FormControlLabel,
    List,
    ListItem,
    ListItemText,
    Dialog,
    DialogContent,
    DialogActions,
    withStyles,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import {
    ExpandMore,
    ExpandLess,
    AddPhotoAlternate,
    Description,
    Save,
    ArrowBack,
    Delete,
    Visibility
} from '@material-ui/icons';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import { WorkshopEquipamentAddService } from './service';

const styles = theme => ({
    root: {
        padding: theme.spacing(2),
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
    },
    sectionCard: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 6,
        marginBottom: theme.spacing(2),
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0, 0, 0, .1)',
        overflow: 'hidden',
    },
    sectionHeader: {
        cursor: 'pointer',
        padding: theme.spacing(1, 2),
        backgroundColor: '#f8f9fa',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#e9ecef',
        },
    },
    sectionBody: {
        padding: theme.spacing(2),
    },
    sugestoesList: {
        position: 'absolute',
        zIndex: 10,
        width: '100%',
        maxHeight: 200,
        overflowY: 'auto',
        backgroundColor: 'white',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
    },
    fotoContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    fotoItem: {
        position: 'relative',
        display: 'inline-block',
    },
    fotoThumb: {
        width: 120,
        height: 120,
        objectFit: 'cover',
        cursor: 'pointer',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
    },
    deleteButton: {
        position: 'absolute',
        top: 0,
        right: 0,
        minWidth: 'auto',
        padding: 4,
        backgroundColor: 'rgba(255,255,255,0.8)',
    },
    laudoItem: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    disabledSection: {
        pointerEvents: 'none',
        opacity: 0.5,
    },
    hierarchySelect: {
        marginBottom: theme.spacing(2),
    },
    selectRow: {
        display: 'flex',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
        marginBottom: theme.spacing(2),
    },
    selectField: {
        flex: '1 1 280px',
        minWidth: 200,
    },
    loadingIndicator: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: '0.85rem',
        marginTop: theme.spacing(0.5),
    },
});

class WorkshopEquipamentAddPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Dados do catálogo hierárquico
            categorias: [],
            produtos: [],
            servicos: [],
            loadingCategorias: false,
            loadingProdutos: false,
            loadingServicos: false,

            equipamentoAtual: null,
            sections: {
                dados: true,
                fotos: true,
                laudos: true
            },
            formData: {
                categoria_id: '',
                produto_id: '',
                servico_id: '',
                marca: '',
                modelo: '',
                serie: '',
                ca: '',
                obstec: '',
                localizacao: '',
                proxima_revisao: '',
                ultima_revisao: '',
                ativo: true
            },
            fotos: {
                antes: [],
                depois: []
            },
            laudos: [],
            modalImagemAberta: false,
            imagemModalUrl: '',
            cliente: {
                id: 1,
                nome: 'Cliente Teste'
            },
            loading: false
        };
    }

    componentDidMount() {
        this.initAddEquip();
    }

    componentWillUnmount() {
        this.cleanupAddEquip();
    }

    initAddEquip = () => {
        this.carregarCategorias();

        const editId = localStorage.getItem('add_equip_edit');
        if (editId && editId !== 'null' && editId.trim() !== '') {
            this.carregarEquipamento(editId);
        }
    };

    cleanupAddEquip = () => {
        this.setState({
            categorias: [],
            produtos: [],
            servicos: [],
            equipamentoAtual: null,
            formData: {
                categoria_id: '',
                produto_id: '',
                servico_id: '',
                marca: '',
                modelo: '',
                serie: '',
                ca: '',
                obstec: '',
                localizacao: '',
                proxima_revisao: '',
                ultima_revisao: '',
                ativo: true
            },
            fotos: { antes: [], depois: [] },
            laudos: []
        });
    };

    // ─── SELEÇÃO HIERÁRQUICA: Categoria → Produto → Serviço ──────────

    carregarCategorias = async () => {
        this.setState({ loadingCategorias: true });
        try {
            const categorias = await WorkshopEquipamentAddService.getCategorias();
            this.setState({ categorias, loadingCategorias: false });
        } catch (error) {
            console.error('Erro ao carregar categorias:', error);
            this.setState({ loadingCategorias: false });
            Swal.fire('Erro', 'Não foi possível carregar as categorias', 'error');
        }
    };

    handleCategoriaChange = async (event) => {
        const categoriaId = event.target.value;

        // Reset dependentes
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                categoria_id: categoriaId,
                produto_id: '',
                servico_id: ''
            },
            produtos: [],
            servicos: [],
            loadingProdutos: true,
            loadingServicos: false
        }));

        if (!categoriaId) {
            this.setState({ loadingProdutos: false });
            return;
        }

        try {
            const produtos = await WorkshopEquipamentAddService.getProdutosByCategoria(categoriaId);
            this.setState({ produtos, loadingProdutos: false });
        } catch (error) {
            console.error('Erro ao carregar produtos:', error);
            this.setState({ loadingProdutos: false });
            Swal.fire('Erro', 'Não foi possível carregar os produtos', 'error');
        }
    };

    handleProdutoChange = async (event) => {
        const produtoId = event.target.value;

        // Reset serviço
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                produto_id: produtoId,
                servico_id: ''
            },
            servicos: [],
            loadingServicos: true
        }));

        if (!produtoId) {
            this.setState({ loadingServicos: false });
            return;
        }

        try {
            const servicos = await WorkshopEquipamentAddService.getServicosByProduto(produtoId);
            this.setState({ servicos, loadingServicos: false });
        } catch (error) {
            console.error('Erro ao carregar serviços:', error);
            this.setState({ loadingServicos: false });
            Swal.fire('Erro', 'Não foi possível carregar os serviços', 'error');
        }
    };

    handleServicoChange = (event) => {
        const servicoId = event.target.value;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                servico_id: servicoId
            }
        }));
    };

    // ─── EQUIPAMENTO ─────────────────────────────────────────────────

    carregarEquipamento = async (id) => {
        try {
            const data = await WorkshopEquipamentAddService.getEquipmentDetails(id);

            const formData = {
                categoria_id: data.equipamento.categoria_id || '',
                produto_id: data.equipamento.produto_id || '',
                servico_id: data.equipamento.servico_id || '',
                marca: data.equipamento.marca || '',
                modelo: data.equipamento.modelo || '',
                serie: data.equipamento.serie || '',
                ca: data.equipamento.ca || '',
                obstec: data.equipamento.obstec || '',
                localizacao: data.equipamento.localizacao || '',
                proxima_revisao: data.equipamento.proxima_revisao || '',
                ultima_revisao: data.equipamento.ultima_revisao || '',
                ativo: data.equipamento.ativo !== false
            };

            this.setState({
                equipamentoAtual: data.equipamento,
                formData,
                fotos: {
                    antes: data.fotos.filter(f => f.momento === 'antes'),
                    depois: data.fotos.filter(f => f.momento === 'depois')
                },
                laudos: data.laudos
            });

            // Carregar dependentes se existem IDs salvos
            if (formData.categoria_id) {
                try {
                    const produtos = await WorkshopEquipamentAddService.getProdutosByCategoria(formData.categoria_id);
                    this.setState({ produtos });

                    if (formData.produto_id) {
                        const servicos = await WorkshopEquipamentAddService.getServicosByProduto(formData.produto_id);
                        this.setState({ servicos });
                    }
                } catch (e) {
                    console.error('Erro ao carregar dependências do equipamento:', e);
                }
            }

        } catch (error) {
            console.error('Erro ao carregar equipamento:', error);
            Swal.fire(this.props.currentLanguage.bepiService.shared.shared_equip_form_error_label, this.props.currentLanguage.bepiService.workshop.workshop_equip_add_load_equip_error, 'error');
        }
    };

    toggleSection = (section) => {
        this.setState(prevState => ({
            sections: {
                ...prevState.sections,
                [section]: !prevState.sections[section]
            }
        }));
    };

    handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [name]: type === 'checkbox' ? checked : value
            }
        }));
    };

    handleAtivoChange = (event) => {
        const ativo = event.target.checked;
        const { currentLanguage } = this.props;

        if (!ativo) {
            Swal.fire({
                title: currentLanguage.bepiService.shared.shared_equip_form_attention_label,
                text: currentLanguage.bepiService.shared.shared_equip_form_deactivate_warning,
                icon: "warning",
                confirmButtonText: currentLanguage.bepiService.shared.shared_equip_form_understand_btn,
                confirmButtonColor: "#d33"
            });
        }

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                ativo
            }
        }));
    };

    salvarEquipamento = async () => {
        const { formData, cliente, equipamentoAtual } = this.state;
        const { currentLanguage } = this.props;

        if (!formData.categoria_id) {
            Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, 'Selecione uma categoria', "error");
            return;
        }

        if (!formData.produto_id) {
            Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, 'Selecione um produto', "error");
            return;
        }

        if (!formData.servico_id) {
            Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, currentLanguage.bepiService.shared.shared_equip_form_select_service_error, "error");
            return;
        }

        this.setState({ loading: true });

        try {
            const equipmentData = {
                ...formData,
                user_id: cliente.id,
                status: formData.ativo ? 'ativo' : 'inativo'
            };

            const result = await WorkshopEquipamentAddService.createEquipment(equipmentData);

            if (result.success) {
                Swal.fire({
                    icon: "success",
                    title: result.message,
                    timer: 2000,
                    showConfirmButton: false
                }).then(() => {
                    const equipmentId = equipamentoAtual?.id || result.data.id;
                    localStorage.setItem("add_equip_edit", equipmentId.toString());
                    if (!equipamentoAtual) {
                        this.setState({ equipamentoAtual: { id: equipmentId } });
                    }
                });
            }

        } catch (error) {
            console.error("Erro ao salvar equipamento:", error);
            Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, error.message || currentLanguage.bepiService.shared.shared_equip_form_save_error, "error");
        } finally {
            this.setState({ loading: false });
        }
    };

    escolherFoto = async (momento) => {
        const { equipamentoAtual } = this.state;
        const { currentLanguage } = this.props;

        if (!equipamentoAtual) {
            Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_attention_label, currentLanguage.bepiService.shared.shared_equip_form_save_first_warning, "warning");
            return;
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = 'image/*';
        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (file) {
                try {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('momento', momento);
                    formData.append('nome', `Foto ${momento}`);

                    const result = await WorkshopEquipamentAddService.uploadPhoto(equipamentoAtual.id, formData);

                    if (result.success) {
                        Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_success_label, result.message, 'success');
                        this.carregarEquipamento(equipamentoAtual.id);
                    }
                } catch (error) {
                    console.error('Erro ao enviar foto:', error);
                    Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, error.message || currentLanguage.bepiService.shared.shared_equip_form_upload_photo_error, 'error');
                }
            }
        };
        input.click();
    };

    visualizarImagem = (url) => {
        this.setState({
            modalImagemAberta: true,
            imagemModalUrl: url
        });
    };

    excluirFoto = async (fotoId) => {
        const { equipamentoAtual } = this.state;
        const { currentLanguage } = this.props;

        Swal.fire({
            title: currentLanguage.bepiService.shared.shared_equip_form_remove_photo_title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.shared.shared_equip_form_yes_btn,
            cancelButtonText: currentLanguage.bepiService.shared.shared_equip_form_no_btn
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await WorkshopEquipamentAddService.deletePhoto(equipamentoAtual.id, fotoId);
                    if (response.success) {
                        Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_success_label, response.message, 'success');
                        this.carregarEquipamento(equipamentoAtual.id);
                    }
                } catch (error) {
                    console.error('Erro ao excluir foto:', error);
                    Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, error.message || currentLanguage.bepiService.shared.shared_equip_form_delete_photo_error, 'error');
                }
            }
        });
    };

    prepararLaudo = async () => {
        const { equipamentoAtual } = this.state;
        const { currentLanguage } = this.props;

        if (!equipamentoAtual) {
            Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_attention_label, currentLanguage.bepiService.shared.shared_equip_form_save_first_warning, "warning");
            return;
        }

        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.pdf,.doc,.docx';
        input.onchange = async (e) => {
            const file = e.target.files[0];
            if (file) {
                try {
                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('nome', `${currentLanguage.bepiService.shared.shared_equip_form_laudo_default_name} ${new Date().toLocaleDateString()}`);
                    formData.append('descricao', currentLanguage.bepiService.shared.shared_equip_form_laudo_default_desc);

                    const result = await WorkshopEquipamentAddService.uploadReport(equipamentoAtual.id, formData);

                    if (result.success) {
                        Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_success_label, result.message, 'success');
                        this.carregarEquipamento(equipamentoAtual.id);
                    }
                } catch (error) {
                    console.error('Erro ao enviar laudo:', error);
                    Swal.fire(currentLanguage.bepiService.shared.shared_equip_form_error_label, error.message || currentLanguage.bepiService.shared.shared_equip_form_upload_laudo_error, 'error');
                }
            }
        };
        input.click();
    };

    excluirLaudo = async (laudoId) => {
        const { equipamentoAtual } = this.state;
        const { currentLanguage } = this.props;

        Swal.fire({
            title: currentLanguage.bepiService.shared.shared_equip_form_remove_laudo_title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.shared.shared_equip_form_yes_btn,
            cancelButtonText: currentLanguage.bepiService.shared.shared_equip_form_no_btn
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await WorkshopEquipamentAddService.deleteReport(equipamentoAtual.id, laudoId);
                    if (response.success) {
                        Swal.fire('Sucesso', response.message, 'success');
                        this.carregarEquipamento(equipamentoAtual.id);
                    }
                } catch (error) {
                    console.error('Erro ao excluir laudo:', error);
                    Swal.fire('Erro', error.message || 'Não foi possível excluir o laudo', 'error');
                }
            }
        });
    };

    // ─── RENDER: Seleção hierárquica ─────────────────────────────────

    renderHierarchySelects = () => {
        const { classes } = this.props;
        const {
            formData,
            categorias, produtos, servicos,
            loadingCategorias, loadingProdutos, loadingServicos
        } = this.state;

        return (
            <Box className={classes.selectRow}>
                {/* SELECT CATEGORIA */}
                <FormControl className={classes.selectField} variant="outlined" size="small">
                    <InputLabel id="categoria-label">Categoria</InputLabel>
                    <Select
                        labelId="categoria-label"
                        id="select-categoria"
                        value={formData.categoria_id}
                        onChange={this.handleCategoriaChange}
                        label="Categoria"
                        disabled={loadingCategorias}
                    >
                        <MenuItem value="">
                            <em>{loadingCategorias ? 'Carregando...' : 'Selecione a categoria'}</em>
                        </MenuItem>
                        {categorias.map(cat => (
                            <MenuItem key={cat.id} value={cat.id}>{cat.nome}</MenuItem>
                        ))}
                    </Select>
                    {loadingCategorias && (
                        <Box className={classes.loadingIndicator}>
                            <CircularProgress size={14} /> Carregando categorias...
                        </Box>
                    )}
                </FormControl>

                {/* SELECT PRODUTO */}
                <FormControl className={classes.selectField} variant="outlined" size="small">
                    <InputLabel id="produto-label">Produto</InputLabel>
                    <Select
                        labelId="produto-label"
                        id="select-produto"
                        value={formData.produto_id}
                        onChange={this.handleProdutoChange}
                        label="Produto"
                        disabled={!formData.categoria_id || loadingProdutos}
                    >
                        <MenuItem value="">
                            <em>
                                {!formData.categoria_id
                                    ? 'Selecione a categoria primeiro'
                                    : loadingProdutos
                                        ? 'Carregando...'
                                        : produtos.length === 0
                                            ? 'Nenhum produto encontrado'
                                            : 'Selecione o produto'}
                            </em>
                        </MenuItem>
                        {produtos.map(prod => (
                            <MenuItem key={prod.id} value={prod.id}>{prod.nome}</MenuItem>
                        ))}
                    </Select>
                    {loadingProdutos && (
                        <Box className={classes.loadingIndicator}>
                            <CircularProgress size={14} /> Carregando produtos...
                        </Box>
                    )}
                </FormControl>

                {/* SELECT SERVIÇO */}
                <FormControl className={classes.selectField} variant="outlined" size="small">
                    <InputLabel id="servico-label">Serviço</InputLabel>
                    <Select
                        labelId="servico-label"
                        id="select-servico"
                        value={formData.servico_id}
                        onChange={this.handleServicoChange}
                        label="Serviço"
                        disabled={!formData.produto_id || loadingServicos}
                    >
                        <MenuItem value="">
                            <em>
                                {!formData.produto_id
                                    ? 'Selecione o produto primeiro'
                                    : loadingServicos
                                        ? 'Carregando...'
                                        : servicos.length === 0
                                            ? 'Nenhum serviço encontrado'
                                            : 'Selecione o serviço'}
                            </em>
                        </MenuItem>
                        {servicos.map(srv => (
                            <MenuItem key={srv.id} value={srv.id}>{srv.nome}</MenuItem>
                        ))}
                    </Select>
                    {loadingServicos && (
                        <Box className={classes.loadingIndicator}>
                            <CircularProgress size={14} /> Carregando serviços...
                        </Box>
                    )}
                </FormControl>
            </Box>
        );
    };

    renderDadosEquipamento = () => {
        const { classes } = this.props;
        const { formData, loading } = this.state;
        const { currentLanguage } = this.props;

        return (
            <Box className={classes.sectionBody}>
                {/* Seleção hierárquica: Categoria → Produto → Serviço */}
                {this.renderHierarchySelects()}

                <TextField
                    fullWidth
                    name="marca"
                    label={currentLanguage.bepiService.shared.shared_equip_form_brand_label}
                    value={formData.marca}
                    onChange={this.handleInputChange}
                    margin="normal"
                />

                <TextField
                    fullWidth
                    name="modelo"
                    label={currentLanguage.bepiService.shared.shared_equip_form_model_label}
                    value={formData.modelo}
                    onChange={this.handleInputChange}
                    margin="normal"
                />

                <TextField
                    fullWidth
                    name="serie"
                    label={currentLanguage.bepiService.shared.shared_equip_form_serial_label}
                    value={formData.serie}
                    onChange={this.handleInputChange}
                    margin="normal"
                />

                <TextField
                    fullWidth
                    name="ca"
                    label={currentLanguage.bepiService.shared.shared_equip_form_ca_label}
                    value={formData.ca}
                    onChange={this.handleInputChange}
                    margin="normal"
                />

                <TextField
                    fullWidth
                    name="obstec"
                    label={currentLanguage.bepiService.shared.shared_equip_form_obs_label}
                    value={formData.obstec}
                    onChange={this.handleInputChange}
                    margin="normal"
                    multiline
                    rows={3}
                />

                <TextField
                    fullWidth
                    name="localizacao"
                    label={currentLanguage.bepiService.shared.shared_equip_form_location_label}
                    value={formData.localizacao}
                    onChange={this.handleInputChange}
                    margin="normal"
                />

                <TextField
                    fullWidth
                    name="proxima_revisao"
                    label={currentLanguage.bepiService.shared.shared_equip_form_next_rev_label}
                    type="date"
                    value={formData.proxima_revisao}
                    onChange={this.handleInputChange}
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                />

                <TextField
                    fullWidth
                    name="ultima_revisao"
                    label={currentLanguage.bepiService.shared.shared_equip_form_last_rev_label}
                    type="date"
                    value={formData.ultima_revisao}
                    onChange={this.handleInputChange}
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                />

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={formData.ativo}
                            onChange={this.handleAtivoChange}
                            name="ativo"
                            color="primary"
                        />
                    }
                    label={currentLanguage.bepiService.shared.shared_equip_form_active_label}
                    style={{ marginTop: 16, marginBottom: 16 }}
                />

                <Box display="flex" gap={1}>
                    <Button
                        variant="outlined"
                        startIcon={<ArrowBack />}
                        onClick={() => window.history.back()}
                        disabled={loading}
                    >
                        {currentLanguage.bepiService.shared.shared_equip_form_back_btn}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<Save />}
                        onClick={this.salvarEquipamento}
                        disabled={loading}
                    >
                        {loading ? currentLanguage.bepiService.shared.shared_equip_form_saving_btn : currentLanguage.bepiService.shared.shared_equip_form_save_btn}
                    </Button>
                </Box>
            </Box>
        );
    };

    renderFotos = () => {
        const { classes } = this.props;
        const { fotos, equipamentoAtual } = this.state;
        const secoesBloqueadas = !equipamentoAtual;
        const { currentLanguage } = this.props;

        return (
            <Box className={`${classes.sectionBody} ${secoesBloqueadas ? classes.disabledSection : ''}`}>
                <Box mb={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddPhotoAlternate />}
                        onClick={() => this.escolherFoto('antes')}
                        disabled={secoesBloqueadas}
                    >
                        {currentLanguage.bepiService.shared.shared_equip_form_add_photo_before_btn}
                    </Button>
                    <Box className={classes.fotoContainer}>
                        {fotos.antes.map(foto => (
                            <Box key={foto.id} className={classes.fotoItem}>
                                <img
                                    src={foto.nome_arquivo}
                                    alt="Foto antes"
                                    className={classes.fotoThumb}
                                    onClick={() => this.visualizarImagem(foto.nome_arquivo)}
                                />
                                <IconButton
                                    className={classes.deleteButton}
                                    size="small"
                                    onClick={() => this.excluirFoto(foto.id)}
                                >
                                    <Delete />
                                </IconButton>
                            </Box>
                        ))}
                    </Box>
                </Box>

                <Box mb={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<AddPhotoAlternate />}
                        onClick={() => this.escolherFoto('depois')}
                        disabled={secoesBloqueadas}
                    >
                        {currentLanguage.bepiService.shared.shared_equip_form_add_photo_after_btn}
                    </Button>
                    <Box className={classes.fotoContainer}>
                        {fotos.depois.map(foto => (
                            <Box key={foto.id} className={classes.fotoItem}>
                                <img
                                    src={foto.nome_arquivo}
                                    alt="Foto depois"
                                    className={classes.fotoThumb}
                                    onClick={() => this.visualizarImagem(foto.nome_arquivo)}
                                />
                                <IconButton
                                    className={classes.deleteButton}
                                    size="small"
                                    onClick={() => this.excluirFoto(foto.id)}
                                >
                                    <Delete />
                                </IconButton>
                            </Box>
                        ))}
                    </Box>
                </Box>
            </Box>
        );
    };

    renderLaudos = () => {
        const { classes } = this.props;
        const { laudos, equipamentoAtual } = this.state;
        const secoesBloqueadas = !equipamentoAtual;
        const { currentLanguage } = this.props;

        return (
            <Box className={`${classes.sectionBody} ${secoesBloqueadas ? classes.disabledSection : ''}`}>
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<Description />}
                    onClick={this.prepararLaudo}
                    disabled={secoesBloqueadas}
                    style={{ marginBottom: 16 }}
                >
                    {currentLanguage.bepiService.shared.shared_equip_form_send_laudo_btn}
                </Button>

                <Box>
                    {laudos.map(laudo => (
                        <Box key={laudo.id} className={classes.laudoItem}>
                            <Button
                                href={`/api/laudos/${laudo.nome_arquivo}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {laudo.nome}
                            </Button>
                            <IconButton
                                size="small"
                                onClick={() => this.excluirLaudo(laudo.id)}
                            >
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    };

    renderModalImagem = () => {
        const { classes } = this.props;
        const { modalImagemAberta, imagemModalUrl } = this.state;
        const { currentLanguage } = this.props;

        return (
            <Dialog
                open={modalImagemAberta}
                onClose={() => this.setState({ modalImagemAberta: false })}
                maxWidth="lg"
            >
                <DialogContent>
                    <img
                        src={imagemModalUrl}
                        alt={currentLanguage.bepiService.shared.shared_image_modal_alt}
                        style={{ width: '100%', height: 'auto' }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => this.setState({ modalImagemAberta: false })}
                        color="primary"
                    >
                        {currentLanguage.bepiService.shared.shared_equip_form_close_btn}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    };

    render() {
        const { classes } = this.props;
        const { sections } = this.state;
        const { currentLanguage } = this.props
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/workshop' },
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_equipments, path: '/bepi/workshop/equipaments' },
            { label: currentLanguage.bepiService.workshop.workshop_breadcrumb_add_equipment },
        ];


        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.workshop.workshop_breadcrumb_add_equipment}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>
                    <Card className={classes.sectionCard}>
                        <CardHeader
                            title={currentLanguage.bepiService.shared.shared_equip_form_data_section_title}
                            action={
                                <IconButton onClick={() => this.toggleSection('dados')}>
                                    {sections.dados ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            }
                            className={classes.sectionHeader}
                            onClick={() => this.toggleSection('dados')}
                        />
                        <Collapse in={sections.dados}>
                            <CardContent style={{ padding: 0 }}>
                                {this.renderDadosEquipamento()}
                            </CardContent>
                        </Collapse>
                    </Card>

                    <Card className={classes.sectionCard}>
                        <CardHeader
                            title="📷 Fotos"
                            action={
                                <IconButton onClick={() => this.toggleSection('fotos')}>
                                    {sections.fotos ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            }
                            className={classes.sectionHeader}
                            onClick={() => this.toggleSection('fotos')}
                        />
                        <Collapse in={sections.fotos}>
                            <CardContent style={{ padding: 0 }}>
                                {this.renderFotos()}
                            </CardContent>
                        </Collapse>
                    </Card>

                    <Card className={classes.sectionCard}>
                        <CardHeader
                            title="📑 Laudos"
                            action={
                                <IconButton onClick={() => this.toggleSection('laudos')}>
                                    {sections.laudos ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            }
                            className={classes.sectionHeader}
                            onClick={() => this.toggleSection('laudos')}
                        />
                        <Collapse in={sections.laudos}>
                            <CardContent style={{ padding: 0 }}>
                                {this.renderLaudos()}
                            </CardContent>
                        </Collapse>
                    </Card>

                    {this.renderModalImagem()}
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(WorkshopEquipamentAddPage);
